import { Button, Flex, Link, Text } from '@approvalmax/ui/src/components';
import { actions } from 'modules/common';
import { clearPersistStore } from 'modules/store';
import { memo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PasskeySetupButton } from 'shared/components';
import { useGetTwoFaEnforcementInformation } from 'shared/data/webApp/v1';

import { ConfirmPasskey } from './components/ConfirmPasskey/ConfirmPasskey';
import { messages } from './HardEnforcementStart.messages';
import { HardEnforcementStartSkeleton } from './HardEnforcementStart.skeleton';
import { HardEnforcementStartProps } from './HardEnforcementStart.types';

export const HardEnforcementStart = memo<HardEnforcementStartProps>((props) => {
    const { onStart } = props;

    const dispatch = useDispatch();
    const { data, isLoading } = useGetTwoFaEnforcementInformation();
    const isDefaultEnforcement = Boolean(data?.tfaEnforcementIntegrationTypes.length);

    const [showConfirmPasskey, setShowConfirmPasskey] = useState(false);

    const logout = useCallback(() => dispatch(actions.logout(clearPersistStore)), [dispatch]);

    const handlePasskeySetupSuccess = useCallback(() => {
        setShowConfirmPasskey(true);
    }, []);

    if (showConfirmPasskey) {
        return <ConfirmPasskey />;
    }

    if (isLoading) {
        return <HardEnforcementStartSkeleton />;
    }

    return (
        <Flex direction='column'>
            <Text font='headline' fontSize='small' fontWeight='regular'>
                {messages.title}
            </Text>

            <Text font='body' fontSize='large' fontWeight='regular'>
                {isDefaultEnforcement
                    ? messages.descriptionAdministratorEnforcement
                    : messages.descriptionCompanyEnforcement}
            </Text>

            <Text font='body' fontSize='large' fontWeight='regular'>
                {messages.moreInformation({
                    supportlink: (chunks) => (
                        <Link
                            href='https://support.approvalmax.com/portal/en/newticket'
                            font='body'
                            fontSize='large'
                            fontWeight='regular'
                        >
                            {chunks}
                        </Link>
                    ),
                })}
            </Text>

            <Button onClick={onStart} color='blue80' size='large'>
                {messages.button}
            </Button>

            <PasskeySetupButton block size='large' outline onSuccess={handlePasskeySetupSuccess} />

            <Button onClick={logout} color='blue10' size='large'>
                {messages.logOut}
            </Button>
        </Flex>
    );
});

HardEnforcementStart.displayName = 'HardEnforcementStart';
